import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import { EllipsisPlaceholder } from '../src/EllipsisPlaceholder.tsx';
import type {
	EllipsisDropdownContainerPropsFromState,
	EllipsisDropdownContainerOwnProps,
} from '../src/types.ts';

export const EllipsisDropdownComponent: LoadableType<
	Omit<
		EllipsisDropdownContainerPropsFromState &
			EllipsisDropdownContainerOwnProps & {
				showRevertDialog: () => void;
			},
		'flags'
	>
> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EllipsisDropdown" */ '../src/EllipsisDropdown.tsx'
			)
		).EllipsisDropdownComponent,
	loading: EllipsisPlaceholder,
});

export { Buttons } from '../src/types.ts';
